import { LitElement, html } from 'lit';
import { styles } from './css';
import {
  fetchCart,
  checkProductAvailability,
  addToCart,
} from '@Root/spree/api';
import {
  updateCartIndicator,
  changeProductNameInModal,
  changeProductImageInModal,
  changeProductSizeInfoInModal,
} from '@Root/spree/dom';
import { logErrorToSentry } from '../../../../helpers/helpers';
import find from 'lodash.find';

import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { useCartConfirmationModal } from '../../../../helpers/helpers';
import { debounce } from '../../../../helpers/debounce';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
export class CutToOrderBarrel extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      _ctaDisabled: { type: Boolean },
      _selectedHeight: { type: Number },
      _selectedWidth: { type: Number },
      _selectedQuantity: { type: Number },
      _selectedLaminate: { type: Object },
      _selectedEdgeFinish: { type: Object },
      _selectedPatternDirection: { type: Object },
      _currentSelectionSpreeData: { type: Object },
      _productIsAvailable: { type: Boolean },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      styles,
    ];
  }

  constructor() {
    super();
    this.content = JSON.parse(this.getAttribute('content'));
    this._ctaDisabled = false;
    this._selectedHeight = null;
    this._selectedWidth = null;
    this._selectedQuantity = 1;
    this._selectedLaminate = {};
    this._selectedEdgeFinish = {};
    this._currentSelectionSpreeData = null;
    this._productIsAvailable = false;
  }

  async connectedCallback() {
    super.connectedCallback();

    try {
      await this.setupSpreeData();
    } catch (error) {
      logErrorToSentry(error);
    }

    this._selectedLaminate = this.my3formLaminates[0];
    this._selectedEdgeFinish = this.edgeFinishOptionsArr[0];
  }

  render() {
    return html`
      <div class="barrel-wrapper-expanded print-none">
        <div class="barrel-header">
          <span class="barrel-heavy-text">
            <span>CHOOSE YOUR PRODUCT</span>
          </span>
        </div>
        <div class="gauge-selection">
          <span class="barrel-heavy-text"></span>
          <span class="barrel-heavy-text">Gauge</span>
          <span class="barrel-heavy-text">Front Finish</span>
          <span class="barrel-heavy-text">Back Finish</span>
          ${this.my3formLaminates.map((laminate, index) =>
            this.gaugeSelectionRowHTML(laminate, index)
          )}
        </div>
      </div>
      <div class="barrel-wrapper-expanded print-none">
        <div class="barrel-header">
          <span class="barrel-heavy-text">
            <span>SPECIFY YOUR ORDER</span>
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <p class="barrel-heavy-text">Width</p>
          </span>
          <span class="input-row-value">
            <input
              type="number"
              .value="${this._selectedWidth}"
              min="1"
              step="1"
              max="48"
              placeholder="Inches"
              @keyup="${event => debounce(this.widthSelectedChanged(event))}"
            />
            <p class="barrel-text help-text">Maximum width is 48.00 inches</p>
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <p class="barrel-heavy-text">Height</p>
          </span>
          <span class="input-row-value">
            <input
              type="number"
              .value="${this._selectedHeight}"
              min="1"
              step="1"
              max="96"
              placeholder="Inches"
              @keyup="${event => debounce(this.heightSelectedChanged(event))}"
            />
            <p class="barrel-text help-text">Maximum height is 96.00 inches</p>
          </span>
        </div>
        ${this.patternDirectionText
          ? html`
              <div class="input-row-wrapper">
                <span class="input-row-header">
                  <p class="barrel-heavy-text">Pattern Direction</p>
                </span>
                <span class="input-row-value">
                  <p class="barrel-text">${this.patternDirectionText}</p>
                </span>
              </div>
            `
          : html``}
        <div class="input-row-wrapper">
          <span class="input-row-header">
            <p class="barrel-heavy-text">Edge Finish</p>
          </span>
          <span class="input-row-value column-direction">
            ${this.edgeFinishOptionsArr.map((edgeFinishOption, index) =>
              this.edgeFinishOptionsHTML(edgeFinishOption, index)
            )}
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <p class="barrel-heavy-text">Quantity</p>
          </span>
          <span class="input-row-value">
            <input
              type="number"
              .value="${this._selectedQuantity}"
              min="1"
              step="1"
              placeholder=""
              @keyup="${this.quantitySelectedChanged}"
            />
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header"></span>
          <span class="input-row-value">
            <div class="totals-wrapper">
              <div class="order-totals">
                <p class="barrel-heavy-text">Total(USD)</p>
                <p class="barrel-heavy-text">${this.totalPriceString}</p>
              </div>
              <cta-button
                class="cta-btn"
                cta-data=${this.ctaData}
                cta-type="primary"
                @click="${() => this.addSelectedProductToCart()}"
                .disabled="${this.ctaDisabled}"
              ></cta-button>
            </div>
          </span>
        </div>
      </div>
    `;
  }

  gaugeSelectionRowHTML(laminate, index) {
    return html`
      <span class="radio-wrapper">
        <input
          type="radio"
          id="${laminate.external_id}"
          name="laminates"
          value="${laminate.external_id}"
          .checked="${laminate.external_id ===
            this._selectedLaminate.external_id}"
          @click="${() => {
            this.updateSelectedLaminate(laminate.external_id);
          }}"
        />
      </span>
      <span>${laminate.gauge.description}</span>
      <span>${laminate.front_finish.description}</span>
      <span>${laminate.back_finish.description}</span>
    `;
  }

  edgeFinishOptionsHTML(edgeFinishOption, index) {
    return html`
      <span class="radio-wrapper">
        <input
          type="radio"
          id="edge-finish-${edgeFinishOption[0]}"
          name="edgeFinishOptions"
          value="${edgeFinishOption[0]}"
          .checked="${this._selectedEdgeFinish[0] === edgeFinishOption[0]}"
          @click="${() => {
            this.updateSelectedEdgeFinish(edgeFinishOption);
          }}"
        />
        <label for="edge-finish-${edgeFinishOption[0]}">
          ${edgeFinishOption[1]}
        </label>
      </span>
    `;
  }

  get edgeFinishOptionsArr() {
    if (this.content.direct_product_choices) {
      const edgeFinishOptions = this.content.direct_product_choices.find(
        ({ name }) => name === 'edge_finish'
      );
      return edgeFinishOptions?.option_groups[0]?.options || [];
    }
    return [];
  }

  get my3formLaminates() {
    return this.content.my3form_laminates;
  }

  updateSelectedLaminate(id) {
    this._selectedLaminate = this.my3formLaminates.find(laminate => {
      return laminate.external_id === id;
    });
    this.updateSpreeData();
  }

  updateSelectedEdgeFinish(edgeFinish) {
    this._selectedEdgeFinish = edgeFinish;
    this.updateSpreeData();
  }

  async heightSelectedChanged(event) {
    if (!event || isNaN(event.target?.value)) return;

    let newValue = event.target.value < 0 ? null : event.target.value;
    if (newValue > 96) newValue = 96;
    if (newValue === this._selectedWidth) return;

    this._selectedHeight = newValue;
    await this.updateSpreeData();
  }

  async widthSelectedChanged(event) {
    if (!event || isNaN(event.target?.value)) return;

    let newValue = event.target.value < 0 ? null : event.target.value;
    if (newValue > 48) newValue = 48;
    if (newValue === this._selectedWidth) return;

    this._selectedWidth = newValue;
    await this.updateSpreeData();
  }

  quantitySelectedChanged(event) {
    if (event) {
      if (isNaN(event.target.value)) return;
      let newValue = event.target.value < 0 ? null : event.target.value;
      if (newValue != this._selectedQuantity) {
        this._selectedQuantity = newValue;
        this.updateSpreeData();
      }
    }
  }

  get ctaData() {
    return JSON.stringify({
      text: 'Add to Cart',
      url: '',
      fullWidth: true,
    });
  }

  get patternDirectionText() {
    return this.content.direct_product_pattern_direction || '';
  }

  async updateSpreeData() {
    if (this.allInputsAreValid) {
      await this.getSpreeData(this.spreeParamsObject)
        .then(json => {
          if (json.price) {
            json.price = this.roundedPrice(json.price);
            this._currentSelectionSpreeData = json;
          }
          this.setupSpreeData();
          this._ctaDisabled = false;
        })
        .catch(error => {
          logErrorToSentry(error);
        });
    } else {
      this._currentSelectionSpreeData = null;
    }
  }

  roundedPrice(num) {
    return Math.round(num * 100) / 100;
  }

  formattedDisplayPrice(num) {
    let USDollar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return USDollar.format(num);
  }

  get totalPriceString() {
    let str = '';
    if (this._selectedQuantity && this._currentSelectionSpreeData) {
      const total =
        this._selectedQuantity * this._currentSelectionSpreeData.price;
      str = this.formattedDisplayPrice(total.toFixed(2));
    }
    return str;
  }

  get spreeParamsObject() {
    return {
      laminate_id: this._selectedLaminate.external_id,
      width: this._selectedWidth,
      height: this._selectedHeight,
      my3form_edge_finish_id: this._selectedEdgeFinish[0],
    };
  }

  get allInputsAreValid() {
    return Object.values(this.spreeParamsObject).every(value => !!value);
  }

  getSpreeData(newParams) {
    const params = new URLSearchParams(newParams);

    const spreeDataUrl = `${document.URL}/cut_to_order?${params}`;

    const init = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    this._ctaDisabled = true;
    this.requestUpdate();

    return fetch(spreeDataUrl, init)
      .then(response => {
        this._ctaDisabled = false;
        if (response.ok) {
          return response.json();
        }
        this.requestUpdate();
        return response.ok;
      })
      .catch(error => {
        logErrorToSentry(error);
      });
  }

  async setupSpreeData() {
    const productId = this._currentSelectionSpreeData?.id;
    if (!productId) return;

    this.cart = await fetchCart();
    if (this.cart) updateCartIndicator(this.cart.data.attributes.item_count);

    const productAvailabilityResponse = await checkProductAvailability(
      productId
    );

    this._productIsAvailable = !productAvailabilityResponse.isFail();
    if (this._productIsAvailable) {
      this._productProperties = productAvailabilityResponse.success().included;
    } else {
      this._ctaDisabled = true;
      console.warn('Spree product not available');
    }
  }

  async addSelectedProductToCart() {
    if (!this._productIsAvailable || this._ctaDisabled) return;
    useCartConfirmationModal();
    this.cart = await addToCart(
      this._currentSelectionSpreeData.master_variant_id,
      this._selectedQuantity
    );
    if (this.cart) {
      updateCartIndicator(this.cart.item_count);
      const productSize = find(this._productProperties, {
        attributes: { name: 'size' },
      });
      changeProductNameInModal(this.content.headerStr, '');
      changeProductImageInModal(this.content.imgUrl);
    }
  }

  get ctaDisabled() {
    return (
      !this.totalPriceString || this._ctaDisabled || !this._productIsAvailable
    );
  }
}
customElements.define('cut-to-order-barrel', CutToOrderBarrel);
